// extracted by mini-css-extract-plugin
export default {"container":"FooterLinks_container__LjP9P"};